// eslint-disable-next-line import/prefer-default-export
export const Status = Object.freeze({
  initial: 'INITIAL',
  loading: 'LOADING',
  loaded: 'LOADED',
  error: 'ERROR'
});
